export const hourMask = [/\d/, /\d/, ':', /\d/, /\d/];
